var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCollapseMessage = function SvgCollapseMessage(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 11 14",
    role: "presentation",
    "aria-hidden": true,
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M.22.234A.753.753 0 0 1 1.281.232l3.724 3.7L8.718.22A.753.753 0 0 1 9.781.218a.747.747 0 0 1 .001 1.06L5.54 5.52a.753.753 0 0 1-1.063.002L.221 1.292A.747.747 0 0 1 .219.235m9.562 13.532a.753.753 0 0 1-1.062.002l-3.724-3.7-3.713 3.712a.753.753 0 0 1-1.062.002.747.747 0 0 1-.002-1.06L4.462 8.48a.753.753 0 0 1 1.062-.002l4.257 4.23a.747.747 0 0 1 .001 1.058",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCollapseMessage);
export { ForwardRef as Icon };
export default "img/element-icons/collapse-message.2764ac2.svg";